<template>
  <div>
    <div
      class="vue-lb-container"
      v-show="lightBoxOn"
      v-if="images && images.length > 0"
      ref="container"
    >
      <div class="vue-lb-content">
        <div class="vue-lb-header alignment-container">
          <span></span>
          <button
            v-if="showButtons"
            type="button"
            :title="print"
            class="vue-lb-button-close"
            @click.stop="printFile(images[select].src)"
          >
            <slot name="close">
              <span>
                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="white"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 482.5 482.5"
                  style="enable-background: new 0 0 482.5 482.5"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M399.25,98.9h-12.4V71.3c0-39.3-32-71.3-71.3-71.3h-149.7c-39.3,0-71.3,32-71.3,71.3v27.6h-11.3
                c-39.3,0-71.3,32-71.3,71.3v115c0,39.3,32,71.3,71.3,71.3h11.2v90.4c0,19.6,16,35.6,35.6,35.6h221.1c19.6,0,35.6-16,35.6-35.6
                v-90.4h12.5c39.3,0,71.3-32,71.3-71.3v-115C470.55,130.9,438.55,98.9,399.25,98.9z M121.45,71.3c0-24.4,19.9-44.3,44.3-44.3h149.6
                c24.4,0,44.3,19.9,44.3,44.3v27.6h-238.2V71.3z M359.75,447.1c0,4.7-3.9,8.6-8.6,8.6h-221.1c-4.7,0-8.6-3.9-8.6-8.6V298h238.3
                V447.1z M443.55,285.3c0,24.4-19.9,44.3-44.3,44.3h-12.4V298h17.8c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-330
                c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h19.9v31.6h-11.3c-24.4,0-44.3-19.9-44.3-44.3v-115c0-24.4,19.9-44.3,44.3-44.3h316
                c24.4,0,44.3,19.9,44.3,44.3V285.3z"
                      />
                      <path
                        d="M154.15,364.4h171.9c7.5,0,13.5-6,13.5-13.5s-6-13.5-13.5-13.5h-171.9c-7.5,0-13.5,6-13.5,13.5S146.75,364.4,154.15,364.4
                z"
                      />
                      <path
                        d="M327.15,392.6h-172c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h171.9c7.5,0,13.5-6,13.5-13.5S334.55,392.6,327.15,392.6z"
                      />
                      <path
                        d="M398.95,151.9h-27.4c-7.5,0-13.5,6-13.5,13.5s6,13.5,13.5,13.5h27.4c7.5,0,13.5-6,13.5-13.5S406.45,151.9,398.95,151.9z"
                      />
                    </g>
                  </g>
                </svg>
              </span>
            </slot>
          </button>
          <download-image :imgSrc="images[select].src" class="download-box text-right cursor w-100"></download-image>
          <button
            type="button"
            :title="closeText"
            class="vue-lb-button-close"
            @click.stop="closeLightBox"
          >
            <slot name="close">
              <span>
                <svg
                  fill="white"
                  x="0px"
                  y="0px"
                  width="100%"
                  height="100%"
                  viewBox="0 0 512 512"
                  style="enable-background: new 0 0 512 512"
                >
                  <path
                    d="M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4 L256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1 c-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1 c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"
                  />
                </svg>
              </span>
            </slot>
          </button>
        </div>
        <div class="vue-lb-figure" @click.stop>
          <transition mode="out-in" name="fade">
            <image-view
              :src="images[select].src"
              class="vue-lb-modal-image"
              :alt="images[select].caption"
            ></image-view>
            <!-- <img
              :key="images[select].src"
              :src="images[select].src"
              :srcset="images[select].srcset || ''"
              class="vue-lb-modal-image"
              :alt="images[select].caption"
            />-->
          </transition>

          <slot name="customCaption">
            <div class="vue-lb-info" v-html="images[select].caption" v-show="showCaption"></div>
          </slot>

          <div class="vue-lb-footer">
            <div class="vue-lb-footer-info"></div>
            <div class="vue-lb-footer-count">
              <slot
                name="footer"
                :current="select + 1"
                :total="images.length"
              >{{ select + 1 }} / {{ images.length }}</slot>
            </div>
          </div>
        </div>
      </div>
      <!-- .vue-lb-content -->
      <div class="vue-lb-thumbnail-wrapper">
        <div v-if="showThumbs" class="vue-lb-thumbnail">
          <button
            v-if="images.length > 1"
            type="button"
            class="vue-lb-thumbnail-arrow vue-lb-thumbnail-left"
            :title="previousThumbText"
            @click.stop="previousImage()"
          >
            <slot name="previousThumb">
              <span>
                <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                  <path
                    d="M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z"
                  />
                </svg>
              </span>
            </slot>
          </button>

          <div
            v-for="(image, index) in imagesThumb"
            :key="typeof image === 'string' ? `${image}${index}` : index"
            :class="
              'vue-lb-modal-thumbnail' + (select === index ? '-active' : '')
            "
            :style="{ 'background-image': `url(${image})` }"
            v-show="index >= thumbIndex.begin && index <= thumbIndex.end"
            @click.stop="showImage(index)"
          ></div>

          <button
            v-if="images.length > 1"
            type="button"
            class="vue-lb-thumbnail-arrow vue-lb-thumbnail-right"
            :title="nextThumbText"
            @click.stop="nextImage()"
          >
            <slot name="nextThumb">
              <span>
                <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
                  <path
                    d="M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z"
                  />
                </svg>
              </span>
            </slot>
          </button>
        </div>
        <!-- .vue-lb-thumbnail -->
      </div>
      <button
        v-if="showArrows && images.length > 1"
        type="button"
        class="vue-lb-arrow vue-lb-left"
        :title="previousText"
        @click.stop="previousImage()"
      >
        <slot name="previous">
          <span>
            <svg fill="white" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 512 512">
              <path
                d="M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9 c-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8 L213.7,256z"
              />
            </svg>
          </span>
        </slot>
      </button>

      <button
        v-if="showArrows && images.length > 1"
        type="button"
        class="vue-lb-arrow vue-lb-right"
        :title="nextText"
        @click.stop="nextImage()"
      >
        <slot name="next">
          <span>
            <svg
              fill="white"
              x="0px"
              y="0px"
              width="100%"
              height="100%"
              viewBox="0 0 512 512"
              xml:space="preserve"
            >
              <path
                d="M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7 c2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8 L298.3,256z"
              />
            </svg>
          </span>
        </slot>
      </button>
    </div>
    <!-- .vue-lb-container -->
  </div>
</template>

<script>
// import { downloadS3Upload, printS3Upload } from "@/methods/exports";
import Image from "@/components/image.vue";
const downloadImage = () => import("@/components/downloadImage.vue");
export default {
  props: {
    images: {
      type: Array,
      required: true
    },

    disableScroll: {
      type: Boolean,
      default: true
    },

    showLightBox: {
      type: Boolean,
      default: true
    },

    startAt: {
      type: Number,
      default: 0
    },

    nThumbs: {
      type: Number,
      default: 7
    },

    showThumbs: {
      type: Boolean,
      default: true
    },

    // Mode
    autoPlay: {
      type: Boolean,
      default: false
    },

    autoPlayTime: {
      type: Number,
      default: 3000
    },

    siteLoading: {
      default: null
    },

    showCaption: {
      type: Boolean,
      default: false
    },

    showArrows: {
      type: Boolean,
      default: true
    },

    lengthToLoadMore: {
      type: Number,
      default: 0
    },

    closeText: {
      type: String,
      default: "Close (Esc)"
    },

    download: {
      type: String,
      default: "Download"
    },

    print: {
      type: String,
      default: "Print"
    },

    previousText: {
      type: String,
      default: "Previous"
    },

    nextText: {
      type: String,
      default: "Next"
    },

    previousThumbText: {
      type: String,
      default: "Previous"
    },

    nextThumbText: {
      type: String,
      default: "Next"
    },

    scrolltype: Boolean,

    showButtons: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      select: this.startAt,
      lightBoxOn: this.showLightBox,
      timer: null
    };
  },
  components: {
    "image-view": Image,
    downloadImage
  },

  computed: {
    thumbIndex() {
      const halfDown = Math.floor(this.nThumbs / 2);

      if (
        this.select >= halfDown &&
        this.select < this.images.length - halfDown
      )
        return {
          begin: this.select - halfDown + (1 - (this.nThumbs % 2)),
          end: this.select + halfDown
        };

      if (this.select < halfDown)
        return {
          begin: 0,
          end: this.nThumbs - 1
        };

      return {
        begin: this.images.length - this.nThumbs,
        end: this.images.length - 1
      };
    },

    imagesThumb() {
      if (this.siteLoading) {
        return this.images.map(({ thumb }) => ({
          src: thumb,
          loading: this.siteLoading,
          error: this.siteLoading
        }));
      }

      return this.images.map(({ thumb }) => thumb);
    }
  },

  watch: {
    lightBoxOn(value) {
      if (document != null) {
        this.onToggleLightBox(value);
      }
    },

    select() {
      this.$emit("onImageChanged", this.select);

      if (this.select >= this.images.length - this.lengthToLoadMore - 1)
        this.$emit("onLoad");

      if (this.select === this.images.length - 1) this.$emit("onLastIndex");

      if (this.select === 0) this.$emit("onFirstIndex");

      if (this.select === this.startAt) this.$emit("onStartIndex");
    }
  },

  mounted() {
    let Hammer;

    if (typeof window !== "undefined") {
      Hammer = require("hammerjs");
    }
    if (this.autoPlay) {
      this.timer = setInterval(() => {
        this.nextImage();
      }, this.autoPlayTime);
    }

    this.onToggleLightBox(this.lightBoxOn);

    if (this.$refs.container) {
      const hammer = new Hammer(this.$refs.container);

      hammer.on("swiperight", () => {
        this.previousImage();
      });

      hammer.on("swipeleft", () => {
        this.nextImage();
      });
    }
    this.$emit("componentMounted");
  },

  methods: {
    printFile(file) {
      // printS3Upload(file);
    },
    downloadFile(file) {
      // downloadS3Upload(this, file);
    },
    onToggleLightBox(value) {
      if (this.disableScroll) {
        if (value && this.scrolltype) {
          document.querySelector("html").classList.add("no-scroll");
        } else {
          document.querySelector("html").classList.remove("no-scroll");
        }
      }

      if (value) {
        document.querySelector("body").classList.add("vue-lb-open");
      } else {
        document.querySelector("body").classList.remove("vue-lb-open");
      }

      this.$emit("onOpened", value);

      if (value) {
        document.addEventListener("keydown", this.addKeyEvent);
      } else {
        document.removeEventListener("keydown", this.addKeyEvent);
      }
    },

    showImage(index) {
      this.$set(this, "lightBoxOn", true);
      this.$set(this, "select", index);
    },

    addKeyEvent(event) {
      if (event.keyCode === 37) this.previousImage(); // left arrow
      if (event.keyCode === 39) this.nextImage(); // right arrow
      if (event.keyCode === 27) this.closeLightBox(); // esc
    },

    closeLightBox() {
      this.$emit("lightBoxClosed");
      this.$set(this, "lightBoxOn", false);
    },

    nextImage() {
      this.$set(this, "select", (this.select + 1) % this.images.length);
    },

    previousImage() {
      this.$set(
        this,
        "select",
        (this.select + this.images.length - 1) % this.images.length
      );
    }
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.addKeyEvent);

    if (this.autoPlay) {
      clearInterval(this.timer);
    }
  }
};
</script>
<style lang="scss" scoped>
.vue-lb-modal-image{
  height:300px;
  overflow-y: scroll;
}

.vue-lb-modal-image::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  border-radius: 10px;
}
 
/* Handle */
.vue-lb-modal-image::-webkit-scrollbar-thumb {
  background: red; 
  border-radius: 10px;
}

/* Handle on hover */
.vue-lb-modal-image::-webkit-scrollbar-thumb:hover {
  background: #b30000; 
}
.vue-lb-modal-thumbnail-active{
  box-shadow:none!important;
}
</style>